import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock-price`;

export async function importStockPrices(file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiFetch(`${BASE_URL}/import`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Price import failed");
  }
  return res.json();
}

export async function fetchNsePrices(indexName) {
  const query = indexName ? `?index=${encodeURIComponent(indexName)}` : "";
  const res = await apiFetch(`${BASE_URL}/fetch/nse${query}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "NSE price fetch failed");
  }
  return res.json();
}

export async function getPriceHistory(symbol) {
  const res = await apiFetch(`${BASE_URL}/history?symbol=${encodeURIComponent(symbol)}`);
  if (!res.ok) {
    return { symbol, stockName: null, points: [] };
  }
  return res.json();
}

export async function getLatestPrice(symbol) {
  const data = await getPriceHistory(symbol);
  const points = data?.points ?? [];
  if (points.length === 0) return null;
  const last = points[points.length - 1];
  return { price: last.price, priceDate: last.priceDate, symbol };
}
